import type { TagProps, TagVariant } from './Tag.types'
import cn from 'classnames'
import Icon from '../icon/Icon'
import { Typography } from '../typography'
import styles from './Tag.module.css'

const TYPOGRAPHY_VARIANT_BY_SIZE = {
  M: 'body-s-bold-tight',
  S: 'body-xs-bold-tight',
} as const

const VARIANT_CLASS: Record<TagVariant, string> = {
  'primary': styles.variantPrimary,
  'primary-tinted': styles.variantPrimaryTinted,
  'success': styles.variantSuccess,
  'success-tinted': styles.variantSuccessTinted,
  'neutral': styles.variantNeutral,
  'neutral-tinted': styles.variantNeutralTinted,
  'strong-tinted': styles.variantStrongTinted,
  'totally': styles.variantTotally,
  'primavera': styles.variantPrimavera,
  'warning-tinted': styles.variantWarningTinted,
  'danger-tinted': styles.variantDangerTinted,
  'informative-tinted': styles.variantInformativeTinted,
}

export function Tag({ ref, children, size = 'M', variant = 'primary', icon, className, ...rest }: TagProps) {
  return (
    <div
      ref={ref}
      {...rest}
      className={cn(
        styles.tag,
        styles[`size${size}`],
        VARIANT_CLASS[variant],
        className,
      )}
    >
      {icon && <Icon className={cn(styles.icon, 'uds-tag-icon')} glyph={icon} size={16} />}
      <Typography className="uds-tag-text" variant={TYPOGRAPHY_VARIANT_BY_SIZE[size]}>{children}</Typography>
    </div>
  )
}
